import { useAuthModal } from "../../hooks/authContext";
import "./AuthModal.scss";
import { useEffect, useRef, useState } from "react";

const AuthModal = () => {
  const { isOpen, setIsOpen } = useAuthModal();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, setIsOpen]);

  const handleLoginSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
      localStorage.setItem("rememberedPassword", password); // ⚠️ mettre token à la place
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            <div className="auth-modal-content" ref={modalRef}>
              <h4 className="auth-title">J’AI DÉJÀ UN COMPTE</h4>
              <form className="auth-form" onSubmit={handleLoginSubmit}>
                <input type="text" placeholder="Identifiant ou e-mail*" />
                <input type="password" placeholder="Mot de passe*" />
                <div className="auth-options">
                  <label>
                    <input type="checkbox" />
                    <span>Se souvenir de moi</span>
                  </label>
                  <a href="/">Mot de passe oublié</a>
                </div>
                <button type="submit" className="auth-button">
                  Me connecter
                </button>
              </form>
              <h4 className="auth-title">JE N’AI PAS ENCORE DE COMPTE</h4>
              <form className="auth-form">
                <div className="auth-name-fields">
                  <input type="text" placeholder="Prénom" />
                  <input type="text" placeholder="Nom" />
                </div>
                <input type="text" placeholder="Nom de l’entreprise" />
                <input type="email" placeholder="E-mail*" />
                <input type="password" placeholder="Mot de passe*" />

                <button type="submit" className="auth-button">
                  Créer mon compte
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthModal;
